module.exports = __webpack_public_path__ + "img/mlcisocert_52022-thumbnail.4663ffc7.jpg";